import { UseMutationResult } from 'react-query';

import { ArrowRight2, Location } from 'iconsax-react';
import { useTheme } from 'styled-components';

import { CardAddress } from '@/domain/address/components/Card';
import { DialogDeleteAddress } from '@/domain/address/components/Dialog/DeleteAddress';
import { Address } from '@/domain/address/models/address';
import { useAddressContext } from '@/shared/contexts/AddressContext';
import { executeEvent } from '@/shared/events/Firebase/firebaseEvents';
import { Text } from '@develop-fapp/ui-kit-fapp';

import * as S from './styles';

interface AddAddressProps {
  handleOnSelectUserAddress: (addressToSelect: Address) => void;
  handleOnEditAddress: (id: string) => void;
  isOpenDialogDeleteAddress: boolean;
  onOpenDialogDeleteConfirmation: (id: string) => void;
  onCloseDialogDeleteConfirmation: () => void;
  deleteAddressMutation: UseMutationResult<Address[], unknown, void, unknown>;
}

export const AddAddress: React.FC<AddAddressProps> = ({
  handleOnSelectUserAddress,
  handleOnEditAddress,
  isOpenDialogDeleteAddress,
  onOpenDialogDeleteConfirmation,
  onCloseDialogDeleteConfirmation,
  deleteAddressMutation,
}) => {
  const { colors } = useTheme();

  const { currentAddress, userAddresses, setCurrentStep } = useAddressContext();

  const handleCreateAddress = () => {
    executeEvent('click_newAddress', {});
  };

  return (
    <>
      <S.Wrapper>
        <main>
          <Text variant="h5" weight="bold">
            Endereços
          </Text>
          <div onClick={handleCreateAddress}>
            <Text variant="h9">Adicionar novo endereço</Text>
            <div onClick={() => setCurrentStep('search')}>
              <div>
                <Location size="18" color={colors.green2} variant="Outline" />
                <Text variant="h7" weight="medium" color={colors.green2}>
                  Adicionar endereço
                </Text>
              </div>
              <ArrowRight2 size="18" color={colors.green2} variant="Outline" />
            </div>
          </div>

          <S.Separator>
            <Text variant="h9" color={colors.grey3}>
              ou então
            </Text>
          </S.Separator>

          <div>
            <Text variant="h9" color={colors.grey3}>
              Meus endereços
            </Text>
            <div>
              {userAddresses.map(data => {
                return (
                  <CardAddress
                    className={`btn-address-id-${data.id}`}
                    key={data.id}
                    userAddress={data}
                    isCurrentAddress={
                      currentAddress !== null
                        ? data.id === currentAddress.id
                        : false
                    }
                    onSelect={handleOnSelectUserAddress}
                    onEdit={handleOnEditAddress}
                    onDelete={onOpenDialogDeleteConfirmation}
                  />
                );
              })}
            </div>
          </div>
        </main>
      </S.Wrapper>

      <DialogDeleteAddress
        isOpen={isOpenDialogDeleteAddress}
        onClose={onCloseDialogDeleteConfirmation}
        deleteAddressMutation={deleteAddressMutation}
      />
    </>
  );
};
